import { render, staticRenderFns } from "./DeptKolView.vue?vue&type=template&id=814e4e52&scoped=true"
import script from "./DeptKolView.vue?vue&type=script&lang=js"
export * from "./DeptKolView.vue?vue&type=script&lang=js"
import style0 from "./DeptKolView.vue?vue&type=style&index=0&id=814e4e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814e4e52",
  null
  
)

export default component.exports